import Phaser from 'phaser';
import { adventureScenes } from '../content/scenes';
import type { EventBus } from './events/EventBus';
import { GAME_HEIGHT, GAME_WIDTH } from './config';
import { AdventureScene } from './scenes/AdventureScene';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { VejleMapScene } from './scenes/VejleMapScene';

export interface GameController {
  game: Phaser.Game;
  openScene(sceneId: string, locationId: string): void;
  returnToMap(): void;
  playAnimation(animationId: string): void;
  destroy(): void;
}

export function createGame(events: EventBus): GameController {
  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'game-canvas',
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: '#07131e',
    scene: [BootScene, PreloadScene, VejleMapScene, AdventureScene],
    render: { antialias: true, pixelArt: false, roundPixels: false },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: GAME_WIDTH,
      height: GAME_HEIGHT,
    },
    input: { activePointers: 2 },
  });

  return {
    game,
    openScene(sceneId) {
      if (!adventureScenes[sceneId]) throw new Error(`Ukendt scene: ${sceneId}`);
      game.scene.stop('VejleMap');
      game.scene.start('Adventure', { sceneId });
    },
    returnToMap() {
      game.scene.stop('Adventure');
      game.scene.start('VejleMap');
    },
    playAnimation(animationId) {
      events.emit('animation:command', { animationId });
    },
    destroy() {
      game.destroy(true);
    },
  };
}
